import React from "react";
import { Button, Modal, } from "antd";
import { IconClose } from "../../icons";
import AddEdlLInstanceNew from "./AddEdlLInstanceNew";
import AddEdlLInstanceFile from "./AddEdlLInstanceFile";
import { useDispatch } from "react-redux";
import { setProgress,  switchAddSuccess } from "../../store/edl";

function ModalAddLInctance({ open, close, item, type }) {
	const dispatch = useDispatch;

	return (
		<Modal
			open={open}
			closable={false}
			footer={null}
			centered
			
		>
			
			{type === "single" && <AddEdlLInstanceNew close={close} item={item} />}
			{type === "file" && <AddEdlLInstanceFile close={close} item={item} />}
		</Modal>
	)
}



export default ModalAddLInctance;
